<template>
  <b-row>
    <b-col>
      <b-form-group :label="label">
        <b-form-radio-group
          :name="fieldName"
          @input="updateValue($event)"
          :value="value"
          :options="options"
          :required="required"
          v-bind="$attrs"
        ></b-form-radio-group>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    fieldName: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: String,
      required: true,
      default: ""
    }
  },
  methods: {
    updateValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style lang="scss" scoped></style>
